import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;

  .MuiPaper-root {
    width: 100%;
  }

  .MuiTable-root {
    width: 100%;
  }

  &.borderCustom .MuiTableCell-root {
    border: 1px solid ${(props) => props.theme.table.borderCell};
  }

  &.odd-even {
    .MuiTableBody-root {
      .MuiTableRow-root {
        &:nth-of-type(even) {
          background-color: ${(props) => props.theme.palette.action.hover};
        }
      }
    }
  }

  .stickyFirstCol {
    &.MuiTableRow-root {
      background-color: ${(props) => props.theme.table.bgRowOld};
      &:nth-of-type(even) {
        background-color: ${(props) => props.theme.table.bgRowEven};
      }
      .MuiTableCell-root {
        &:first-child {
          left: 0;
          z-index: 2;
          position: sticky;
          background-color: inherit;
          &.MuiTableCell-stickyHeader {
            z-index: 10;
          }
        }
        &.MuiTableCell-stickyHeader {
          background-color: ${(props) => props.theme.table.bgHeader};
        }
      }
      &:hover {
        background-color: ${(props) => props.theme.table.hover};
      }
    }
  }
  .stickyFirstRow {
    &.MuiTableRow-root {
      background-color: ${(props) => props.theme.table.bgRowOld};
      &:nth-of-type(even) {
        background-color: ${(props) => props.theme.table.bgRowEven};
      }
      &:first-child {
        .MuiTableCell-root {
          top: 40px;
          z-index: 2;
          position: sticky;
          background-color: inherit;
        }
      }

      &:hover {
        background-color: ${(props) => props.theme.table.hover};
      }
    }
  }

  &.no-style {
    .MuiPaper-root {
      border: 0;
      box-shadow: none;
    }

    .MuiTableCell-head,
    .MuiTableCell-root {
      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }

    .MuiTableRow-root {
      &:last-child {
        .MuiTableCell-root {
          border-bottom: 0;
        }
      }
    }
  }

  &.table-responsive {
    ${(props) => props.theme.breakpoints.down(props.$breakpointResponsive)} {
      .MuiTableHead-root {
        display: none;
      }

      .MuiTableRow-root {
        display: flex;
        flex-direction: column;
        width: 100%;

        .MuiTableCell-root {
          display: flex;
          justify-content: space-between;

          &::before {
            content: attr(data-label);
            display: inline-flex;
            margin-right: 10px;
            font-weight: bold;
          }
        }
      }
    }

    ${(props) => props.theme.breakpoints.down(props.$breakpointResponsive2)} {
      .MuiTableRow-root {
        .MuiTableCell-root {
          flex-direction: column;
        }
      }
    }
  }
`;
